module.exports = __webpack_public_path__ + "static/media/June 2022.78784ee2.svg";